import {
  AlertCircle,
  AlertOctagon,
  AlertTriangle,
  ArrowDown,
  ArrowDownAZ,
  ArrowDownNarrowWide,
  ArrowDownWideNarrow,
  ArrowLeft,
  ArrowLeftRight,
  ArrowRight,
  ArrowUp,
  ArrowUpDown,
  AudioLines,
  BadgeCheck,
  Ban,
  Book,
  Briefcase,
  Bug,
  Building,
  Calculator,
  CalendarDays,
  Camera,
  ChartBar,
  ChartColumn,
  ChartLine,
  ChartPie,
  Check,
  CheckCircle,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  ChevronsRight,
  Circle,
  CircleArrowDown,
  CircleMinus,
  Clipboard,
  Clock,
  Cloud,
  CloudDownload,
  CloudUpload,
  Code,
  CodeXml,
  Cog,
  Columns2,
  Copy,
  CornerDownLeft,
  CreditCard,
  DollarSign,
  Dot,
  Download,
  ExternalLink,
  Eye,
  EyeOff,
  FastForward,
  File,
  FileSymlink,
  FileText,
  Filter,
  FilterX,
  Flag,
  Folder,
  FolderOpen,
  FolderPlus,
  GalleryVerticalEnd,
  Gauge,
  Gift,
  GitCompare,
  Globe,
  Grid3x3,
  GripVertical,
  Hand,
  Heart,
  HelpCircle,
  History,
  Home,
  Image,
  Import,
  Inbox,
  Info,
  Key,
  Languages,
  Layers,
  LifeBuoy,
  Lightbulb,
  Link,
  List,
  ListTodo,
  Lock,
  LogIn,
  LogOut,
  LucideIcon,
  Mail,
  Maximize,
  Megaphone,
  Menu,
  MessageCircle,
  MessageSquare,
  Mic,
  Minimize,
  Minimize2,
  Minus,
  MinusCircle,
  MoreHorizontal,
  Move,
  Music,
  Palette,
  PenSquare,
  Pencil,
  PiggyBank,
  Play,
  Plus,
  Presentation,
  Printer,
  Radio,
  RefreshCw,
  Rewind,
  RotateCcw,
  Rows2,
  Rss,
  Search,
  Send,
  Settings,
  Share,
  Share2,
  Smartphone,
  Smile,
  Sparkles,
  Square,
  SquarePlus,
  SquaresIntersect,
  Star,
  StarOff,
  Sun,
  TableProperties,
  Tag,
  Timer,
  Tractor,
  Trash2,
  TriangleAlert,
  Upload,
  User,
  UserPlus,
  Users,
  Video,
  Volume2,
  VolumeX,
  X,
  XCircle,
  Zap,
  ZoomIn,
  ZoomOut,
} from 'lucide-react';
import * as React from 'react';
import { ComponentProps } from 'react';
import { tv } from 'tailwind-variants';
import { cx } from '../util';

const iconStyles = tv({
  variants: {
    intent: {
      none: '',
      primary: 'text-purple-600 dark:text-purple-400',
      success: 'text-green-600 dark:text-green-400',
      warning: 'text-orange-600 dark:text-orange-400',
      danger: 'text-red-600 dark:text-red-400',
    },
  },
});

/**
 * A static registry of common icons to avoid using DynamicIcon which bloats the bundle with thousands of chunks.
 */
export const STATIC_REGISTRY = {
  'alert-circle': AlertCircle,
  'alert-octagon': AlertOctagon,
  'alert-triangle': AlertTriangle,
  'arrow-down-a-z': ArrowDownAZ,
  'arrow-down-narrow-wide': ArrowDownNarrowWide,
  'arrow-down-wide-narrow': ArrowDownWideNarrow,
  'arrow-down': ArrowDown,
  'arrow-left-right': ArrowLeftRight,
  'arrow-left': ArrowLeft,
  'arrow-right': ArrowRight,
  'arrow-up-down': ArrowUpDown,
  'arrow-up': ArrowUp,
  'audio-lines': AudioLines,
  'badge-check': BadgeCheck,
  'calendar-days': CalendarDays,
  'chart-bar': ChartBar,
  'chart-column': ChartColumn,
  'chart-line': ChartLine,
  'chart-pie': ChartPie,
  'check-circle': CheckCircle,
  'chevron-down': ChevronDown,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  'chevron-up': ChevronUp,
  'chevrons-right': ChevronsRight,
  'circle-arrow-down': CircleArrowDown,
  'circle-minus': CircleMinus,
  'cloud-download': CloudDownload,
  'cloud-upload': CloudUpload,
  'code-xml': CodeXml,
  'columns-2': Columns2,
  'corner-down-left': CornerDownLeft,
  'credit-card': CreditCard,
  'dollar-sign': DollarSign,
  'external-link': ExternalLink,
  'eye-off': EyeOff,
  'fast-forward': FastForward,
  'file-symlink': FileSymlink,
  'file-text': FileText,
  'filter-x': FilterX,
  'folder-open': FolderOpen,
  'folder-plus': FolderPlus,
  'gallery-vertical-end': GalleryVerticalEnd,
  'git-compare': GitCompare,
  'grid-3x3': Grid3x3,
  'grip-vertical': GripVertical,
  'help-circle': HelpCircle,
  import: Import,
  'life-buoy': LifeBuoy,
  'list-todo': ListTodo,
  'log-in': LogIn,
  'log-out': LogOut,
  'message-circle': MessageCircle,
  'message-square': MessageSquare,
  'minimize-2': Minimize2,
  'minus-circle': MinusCircle,
  'more-horizontal': MoreHorizontal,
  'pen-square': PenSquare,
  'piggy-bank': PiggyBank,
  'refresh-cw': RefreshCw,
  'rotate-ccw': RotateCcw,
  'rows-2': Rows2,
  'share-2': Share2,
  'square-plus': SquarePlus,
  'squares-intersect': SquaresIntersect,
  'star-off': StarOff,
  'table-properties': TableProperties,
  'trash-2': Trash2,
  'triangle-alert': TriangleAlert,
  'user-plus': UserPlus,
  'volume-2': Volume2,
  'volume-x': VolumeX,
  'x-circle': XCircle,
  'zoom-in': ZoomIn,
  'zoom-out': ZoomOut,
  ban: Ban,
  book: Book,
  briefcase: Briefcase,
  bug: Bug,
  building: Building,
  calculator: Calculator,
  camera: Camera,
  check: Check,
  circle: Circle,
  clipboard: Clipboard,
  clock: Clock,
  cloud: Cloud,
  code: Code,
  cog: Cog,
  copy: Copy,
  download: Download,
  dot: Dot,
  eye: Eye,
  file: File,
  filter: Filter,
  flag: Flag,
  folder: Folder,
  gauge: Gauge,
  gift: Gift,
  globe: Globe,
  hand: Hand,
  heart: Heart,
  history: History,
  home: Home,
  image: Image,
  inbox: Inbox,
  info: Info,
  key: Key,
  languages: Languages,
  layers: Layers,
  lightbulb: Lightbulb,
  link: Link,
  list: List,
  lock: Lock,
  mail: Mail,
  maximize: Maximize,
  megaphone: Megaphone,
  menu: Menu,
  mic: Mic,
  minimize: Minimize,
  minus: Minus,
  move: Move,
  music: Music,
  palette: Palette,
  pencil: Pencil,
  play: Play,
  plus: Plus,
  presentation: Presentation,
  printer: Printer,
  radio: Radio,
  rewind: Rewind,
  rss: Rss,
  search: Search,
  send: Send,
  settings: Settings,
  share: Share,
  smartphone: Smartphone,
  smile: Smile,
  sparkles: Sparkles,
  square: Square,
  star: Star,
  sun: Sun,
  tag: Tag,
  timer: Timer,
  tractor: Tractor,
  upload: Upload,
  user: User,
  users: Users,
  video: Video,
  x: X,
  zap: Zap,
} as const satisfies Record<string, LucideIcon>;

// Temporary mapping of Blueprint to Lucide icon names to simplify migration
export const BLUEPRINT_TO_LUCIDE = {
  add: 'plus',
  annotation: 'pen-square',
  announcement: 'megaphone',
  antenna: 'radio',
  'automatic-updates': 'refresh-cw',
  'ban-circle': 'circle-minus',
  'bank-account': 'piggy-bank',
  blank: 'dot',
  calendar: 'calendar-days',
  'caret-down': 'chevron-down',
  chart: 'chart-line',
  chat: 'message-square',
  clean: 'sparkles',
  'code-block': 'code-xml',
  comment: 'message-circle',
  comparison: 'git-compare',
  cross: 'x',
  'cross-circle': 'x-circle',
  dashboard: 'gauge',
  disable: 'ban',
  document: 'file',
  'document-open': 'file-symlink',
  'document-share': 'external-link',
  dollar: 'dollar-sign',
  'double-chevron-right': 'chevrons-right',
  'drag-handle-vertical': 'grip-vertical',
  duplicate: 'copy',
  edit: 'pencil',
  emoji: 'smile',
  endorsed: 'badge-check',
  envelope: 'mail',
  error: 'alert-circle',
  export: 'upload',
  'eye-open': 'eye',
  feed: 'rss',
  'filter-remove': 'filter-x',
  flash: 'sun',
  'folder-close': 'folder',
  'folder-new': 'folder-plus',
  form: 'list-todo',
  fullscreen: 'maximize',
  'gift-box': 'gift',
  'globe-network': 'globe',
  'group-item': 'layers',
  help: 'help-circle',
  'high-priority': 'alert-triangle',
  'info-sign': 'info',
  intersection: 'squares-intersect',
  issue: 'alert-octagon',
  'key-enter': 'corner-down-left',
  label: 'file-text',
  'layout-two-rows': 'rows-2',
  lifesaver: 'life-buoy',
  lightning: 'zap',
  'manually-entered-data': 'pencil',
  media: 'image',
  'menu-closed': 'chevron-right',
  'merge-columns': 'columns-2',
  microphone: 'mic',
  'mobile-phone': 'smartphone',
  more: 'more-horizontal',
  'new-person': 'user-plus',
  'new-text-box': 'square-plus',
  office: 'building',
  'panel-stats': 'chart-bar',
  people: 'users',
  person: 'user',
  'pie-chart': 'chart-pie',
  print: 'printer',
  projects: 'gallery-vertical-end',
  properties: 'table-properties',
  record: 'circle',
  refresh: 'refresh-cw',
  remove: 'minus-circle',
  reset: 'rotate-ccw',
  'send-message': 'send',
  'send-to': 'share',
  share: 'external-link',
  'shorten-text': 'minimize-2',
  'small-cross': 'x',
  'small-info-sign': 'info',
  'small-tick': 'check',
  'social-media': 'share-2',
  sort: 'arrow-up-down',
  'sort-alphabetical': 'arrow-down-a-z',
  'sort-asc': 'arrow-down-narrow-wide',
  'sort-desc': 'arrow-down-wide-narrow',
  'star-empty': 'star-off',
  stop: 'square',
  stopwatch: 'timer',
  style: 'palette',
  'swap-horizontal': 'arrow-left-right',
  'swap-vertical': 'arrow-up-down',
  th: 'grid-3x3',
  'th-list': 'list',
  tick: 'check',
  'tick-circle': 'check-circle',
  time: 'clock',
  'timeline-bar-chart': 'chart-column',
  'timeline-line-chart': 'chart-line',
  translate: 'languages',
  trash: 'trash-2',
  updated: 'refresh-cw',
  'volume-off': 'volume-x',
  'volume-up': 'volume-2',
  'warning-sign': 'triangle-alert',
} as const satisfies Record<string, string>;

export type IconName = keyof typeof BLUEPRINT_TO_LUCIDE | keyof typeof STATIC_REGISTRY;

export type Intent = 'none' | 'primary' | 'success' | 'warning' | 'danger';

export type IconProps<T extends Element = Element> = {
  icon: IconName | LucideIcon | Exclude<React.JSX.Element, string> | null | undefined;
  intent?: Intent;
  className?: string;
  size?: number;
  tagName?: keyof React.JSX.IntrinsicElements;
  color?: string;
  lucideProps?: ComponentProps<LucideIcon>;
} & React.HTMLAttributes<T>;

export function Icon({
  className,
  color,
  icon,
  intent,
  tagName: TagName = 'span',
  lucideProps,
  size = 20,
  ...htmlProps
}: IconProps<Element>) {
  if (icon == null || typeof icon === 'boolean') {
    return null;
  }

  if (React.isValidElement(icon)) {
    return icon;
  }

  const LucideIconComponent =
    typeof icon === 'string'
      ? // @ts-ignore
        STATIC_REGISTRY[BLUEPRINT_TO_LUCIDE[icon] || icon]
      : typeof icon === 'function' ||
          (typeof icon === 'object' && icon !== null && typeof (icon as any).render === 'function')
        ? (icon as LucideIcon)
        : undefined;

  if (LucideIconComponent) {
    return (
      <TagName
        {...htmlProps}
        className={cx(
          'clarion-icon inline-flex items-center justify-center shrink-0',
          iconStyles({ intent }),
          icon === 'blank' && 'opacity-0',
          className,
        )}
        style={{ width: size, height: size, color, ...htmlProps.style }}
      >
        <LucideIconComponent size={size} {...(lucideProps as any)} />
      </TagName>
    );
  }
  if (typeof icon === 'string') {
    console.error(
      `Icon ${icon} is not in STATIC_REGISTRY. Please import it directly from lucide-react.`,
    );
  }
  return null;
}
